<template>
  <cs-preloader-overlay :loading="SELF_EMPLOYED_NOTIFICATIONS_LOADING">
    <div :class="$style.container">
      <div :class="$style.header">
        <screen-header
          :title="$t('common.notifications')"
          :is-desktop="isDesktop"
        />
      </div>
      <capusta-content>
        <template v-if="notificationsShown">
          <div
            v-for="({ createdAt, id, message, status }) in notificationList"
            :key="`${id}_${createdAt}`"
            class="notification-list"
          >
            <notification
              :color-overlay="notificationColor(status)"
              image-overlay="self-employed"
            >
              <p><strong>{{ $t('fns.of.russia') }}:</strong>&nbsp;{{ message }}</p>
              <a
                slot="button"
                href="https://lknpd.nalog.ru/messages/notifications"
                class="button thin clear"
                target="_blank"
                @click="handleClickNotification(id)"
              >
                <span>{{ notificationLabel(status) }}</span>
              </a>
            </notification>
          </div>
        </template>
        <template v-else>
          <div class="notification-empty">{{ $t('no.notifications.for.you') }}</div>
        </template>
      </capusta-content>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import logrocket from '@/services/logrocket';

import ScreenHeader from 'molecules/common/ScreenHeader';
import { CapustaContent } from 'modules/CapustaLayout';
import Notification from 'modules/Notification/Notification';

export default {
  name: 'Notifications',
  components: {
    ScreenHeader,
    CapustaContent,
    Notification,
  },
  computed: {
    notificationsShown() {
      return this.$validate.isNotEmptyArray(this.SELF_EMPLOYED_NOTIFICATIONS_LIST);
    },
    notificationList() {
      return [
        ...this.SELF_EMPLOYED_NOTIFICATIONS_UNREADED,
        ...this.SELF_EMPLOYED_NOTIFICATIONS_READED,
      ];
    },
    ...mapGetters([
      'isDesktop',
      'SELF_EMPLOYED_NOTIFICATIONS_LIST',
      'SELF_EMPLOYED_NOTIFICATIONS_READED',
      'SELF_EMPLOYED_NOTIFICATIONS_UNREADED',
      'SELF_EMPLOYED_NOTIFICATIONS_LOADING',
    ]),
  },
  methods: {
    async handleClickNotification(notificationId) {
      try {
        await this.UPDATE_SELF_EMPLOYED_NOTIFICATION(notificationId);
      } catch (error) {
        logrocket.logger(error);
      }

      await this.FETCH_SELF_EMPLOYED_NOTIFICATIONS();
    },
    notificationColor(status) {
      return status === 'NEW' ? '#9B51E0' : 'rgba(40, 41, 61, 0.75)';
    },
    notificationLabel(status) {
      return status === 'NEW' ? this.$t('to.read') : this.$t('common.read');
    },
    ...mapActions(['FETCH_SELF_EMPLOYED_NOTIFICATIONS', 'UPDATE_SELF_EMPLOYED_NOTIFICATION']),
  },
};
</script>

<style lang="sass" module>
  .container
    display: flex
    flex-direction: column
    width: 100%
    padding: 20px 0 60px

    +respond-to('medium')
      padding: 60px 160px

  .header
    margin-bottom: 20px
    padding: 0 20px

    +respond-to('medium')
      margin-bottom: 30px
      padding: 0
</style>

<style lang="sass" scoped>
  .notification-empty
    text-align: center

  .notification-list

    &:not(:last-child)
      margin-bottom: 1px

      +respond-to("medium")
        margin-bottom: 20px

    p
      strong
        font-weight: 600

      span[data-blocked-title]
        display: block

        +respond-to("medium")
          display: inline

      span[data-blocked-link]
        display: inline

        +respond-to("medium")
          display: block

      a
        text-decoration: underline
</style>
